import Api from '@/api'

const state = {
    items: [],
    pageNo: 1,
    pageSize: 10,
    totalCount: 0,
    totalPage: 0
}
const getters = {
    messages: state => state.items,
    mPageNo: state => state.pageNo,
    mPageSize: state => state.pageSize,
    mTotalCount: state => state.totalCount,
    mTotalPage: state => state.totalPage
}
const mutations = {}
const actions = {
    async loadMessages({state}, params) {
        let {data} = await Api.messages(params);
        let {pageNo, pageSize, totalCount, totalPage, items} = data;
        state.pageNo = pageNo;
        state.pageSize = pageSize;
        state.totalCount = totalCount;
        state.totalPage = totalPage;
        state.items = items;
    },
    async recall({state}, params) {
        let {data} = await Api.recall(params);
    },
    async broadcast({state}, params) {
        let {data} = await Api.broadcast(params);
    },
    async multicast({state}, params) {
        return await Api.multicast(params);
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/components/message_store.js